import { useAdminTheme } from "@/admin/AdminTheme";

export function ACard({ children, style, ...rest }) {
  const { c } = useAdminTheme();
  return <div style={{ background: c.surface, border: `1px solid ${c.border}`, borderRadius: 14, padding: 20, ...style }} {...rest}>{children}</div>;
}

export function AButton({ children, variant = "primary", style, ...rest }) {
  const { c } = useAdminTheme();
  const variants = {
    primary: { background: c.primary, color: c.onPrimary, border: "none" },
    soft: { background: c.primarySoft, color: c.primarySoftText, border: "none" },
    outline: { background: "transparent", color: c.onSurface, border: `1px solid ${c.border}` },
    danger: { background: c.danger, color: "#fff", border: "none" },
    ghost: { background: "transparent", color: c.onSurfaceSecondary, border: "none" },
  };
  return (
    <button
      style={{ ...variants[variant], borderRadius: 10, padding: "10px 18px", fontWeight: 700, fontSize: 13, letterSpacing: 0.4, cursor: "pointer", fontFamily: "DM Sans", transition: "opacity 0.2s ease", ...style }}
      onMouseDown={(e) => (e.currentTarget.style.opacity = "0.85")}
      onMouseUp={(e) => (e.currentTarget.style.opacity = "1")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
      {...rest}
    >
      {children}
    </button>
  );
}

export function AInput({ label, style, ...rest }) {
  const { c } = useAdminTheme();
  return (
    <label style={{ display: "block" }}>
      {label && <span style={{ display: "block", fontSize: 11, letterSpacing: 0.6, textTransform: "uppercase", color: c.mutedText, marginBottom: 6, fontWeight: 600 }}>{label}</span>}
      <input
        style={{ width: "100%", background: c.bg, border: `1px solid ${c.border}`, borderRadius: 10, padding: "11px 14px", color: c.onSurface, fontSize: 14, outline: "none", fontFamily: "DM Sans", ...style }}
        {...rest}
      />
    </label>
  );
}

export function ATextarea({ label, style, ...rest }) {
  const { c } = useAdminTheme();
  return (
    <label style={{ display: "block" }}>
      {label && <span style={{ display: "block", fontSize: 11, letterSpacing: 0.6, textTransform: "uppercase", color: c.mutedText, marginBottom: 6, fontWeight: 600 }}>{label}</span>}
      <textarea style={{ width: "100%", background: c.bg, border: `1px solid ${c.border}`, borderRadius: 10, padding: "11px 14px", color: c.onSurface, fontSize: 14, outline: "none", fontFamily: "DM Sans", resize: "vertical", ...style }} {...rest} />
    </label>
  );
}

export function StatCard({ label, value, sub }) {
  const { c } = useAdminTheme();
  return (
    <ACard>
      <div style={{ fontSize: 11, letterSpacing: 0.8, textTransform: "uppercase", color: c.mutedText, fontWeight: 700 }}>{label}</div>
      <div className="font-display" style={{ fontSize: 30, fontWeight: 700, color: c.onSurface, marginTop: 6, letterSpacing: -0.5 }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: c.onSurfaceSecondary, marginTop: 4 }}>{sub}</div>}
    </ACard>
  );
}

export function Badge({ children, tone = "primary" }) {
  const { c } = useAdminTheme();
  const tones = {
    primary: [c.primarySoft, c.primarySoftText],
    success: [c.successSoft, c.success],
    warning: [c.warningSoft, c.warning],
    danger: [c.dangerSoft, c.danger],
    info: [c.infoSoft, c.info],
  };
  const [bg, fg] = tones[tone] || tones.primary;
  return <span style={{ background: bg, color: fg, padding: "3px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>{children}</span>;
}

export const STATUS_TONE = { created: "warning", paid: "success", shipped: "info", delivered: "primary", cancelled: "danger" };

export function AdminPageTitle({ title, subtitle, action }) {
  const { c } = useAdminTheme();
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 12, marginBottom: 22 }}>
      <div>
        <h1 className="font-display" style={{ margin: 0, fontSize: 28, fontWeight: 700, color: c.onSurface, letterSpacing: -0.4 }}>{title}</h1>
        {subtitle && <p style={{ margin: "4px 0 0", color: c.mutedText, fontSize: 14 }}>{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
